
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_j5g25_93",
  "outline": "awsui_outline_4yi2u_j5g25_129",
  "toggle-control": "awsui_toggle-control_4yi2u_j5g25_148",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_j5g25_158",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_j5g25_161",
  "toggle-handle": "awsui_toggle-handle_4yi2u_j5g25_168",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_j5g25_180",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_j5g25_183"
};
  